export const sBreakpoint = 320;
export const mBreakpoint = 768;
export const lBreakpoint = 1280;
export const xlBreakpoint = 1600;
